import { useState, useEffect } from 'react';
import { doc, collection, getDoc } from "firebase/firestore";
import { firestore } from "../firebase-config";
import { id_firebase } from "../content-site";

export function useCompanyData() {
  const [companyData, setCompanyData] = useState({
    name: "",
    cnpj: "",
    address: "",
    phone: "",
    email: "",
    dpo: "#",
    dpoCargo: "#",
  });

  useEffect(() => {
    const revendaRef = doc(collection(firestore, "revenda"), id_firebase);
    getDoc(revendaRef).then((docSnap) => {
      if (docSnap.exists()) {
        const data = docSnap.data();
        setCompanyData({
          name: data.penome_fantasia ?? "",
          cnpj: data.pecpf_cnpj ?? "",
          address: `${data.peendereco_fiscal}, ${data.peendereco_fiscal_numero} - ${data.pebairro_fiscal}, ${data.pecidade} - ${data.peuf}`,
          phone: data.petelefone1 ?? "",
          email: data.peemail ?? "",
        });
      }
    });
  }, []);

  return companyData;
}

// Função que gera as seções com os dados já carregados
export function getPrivacySections(companyData) {
  return [
    {
      id: "intro",
      title: "1. Apresentação",
      content: `A ${companyData.name}, inscrita no CPF/CNPJ sob o nº ${companyData.cnpj}, com sede em ${companyData.address}, respeita sua privacidade e está comprometida em proteger os dados pessoais que você nos fornece. Esta Política de Privacidade descreve como coletamos, usamos, armazenamos e protegemos suas informações, em conformidade com a Lei Geral de Proteção de Dados (LGPD – Lei nº 13.709/2018).`,
    },
    {
      id: "dados",
      title: "2. Dados Coletados",
      content: `Coletamos os seguintes dados pessoais: nome completo, CPF/CNPJ, endereço de e-mail, telefone de contato, endereço residencial ou comercial, dados de navegação (cookies e logs de acesso), informações sobre interesse em veículos e histórico de interações com nosso site.`,
    },
    {
      id: "finalidade",
      title: "3. Finalidade do Tratamento",
      content: `Os dados coletados são utilizados para: (a) responder a solicitações de contato e agendamentos de test drive; (b) enviar propostas comerciais e cotações de veículos; (c) realizar atendimento pós-venda; (d) envio de comunicações de marketing, quando autorizado; (e) cumprimento de obrigações legais e regulatórias; (f) melhoria contínua dos nossos serviços digitais.`,
    },
    {
      id: "compartilhamento",
      title: "4. Compartilhamento de Dados",
      content: `Seus dados poderão ser compartilhados com: fabricantes e distribuidoras de veículos parceiras, instituições financeiras para análise de crédito (mediante seu consentimento), prestadores de serviços de tecnologia e manutenção de sistemas, e autoridades públicas quando exigido por lei. Não vendemos seus dados a terceiros.`,
    },
    {
      id: "retencao",
      title: "5. Retenção e Exclusão",
      content: `Mantemos seus dados pelo período necessário ao cumprimento das finalidades descritas ou conforme exigido por lei. Dados de clientes são retidos por até 5 anos após o encerramento do relacionamento comercial. Você pode solicitar a exclusão a qualquer momento, salvo nos casos em que a lei exija a manutenção.`,
    },
    {
      id: "direitos",
      title: "6. Seus Direitos (LGPD)",
      content: `Conforme a LGPD, você tem direito a: confirmar a existência de tratamento; acessar seus dados; corrigir dados incompletos ou desatualizados; solicitar anonimização, bloqueio ou exclusão de dados desnecessários; portabilidade dos dados; revogação do consentimento; e informação sobre compartilhamento com terceiros. Para exercer seus direitos, entre em contato com nosso DPO.`,
    },
    {
      id: "cookies",
      title: "7. Cookies e Rastreamento",
      content: `Utilizamos cookies essenciais para o funcionamento do site, cookies analíticos (Google Analytics) para entender o comportamento de navegação e cookies de marketing para personalização de anúncios. Você pode gerenciar suas preferências de cookies a qualquer momento nas configurações do seu navegador.`,
    },
    {
      id: "seguranca",
      title: "8. Segurança",
      content: `Adotamos medidas técnicas e organizacionais adequadas para proteger seus dados contra acesso não autorizado, perda, destruição ou divulgação indevida, incluindo criptografia de dados sensíveis, controle de acesso restrito e monitoramento de sistemas.`,
    },
    {
      id: "contato",
      title: "9. Contato e DPO",
      content: `Para dúvidas, solicitações ou exercício dos seus direitos relacionados a esta política, entre em contato:\n\nE-mail: ${companyData.email}\nTelefone: ${companyData.phone}`,
    },
  ];
}